// extracted by mini-css-extract-plugin
export default {"root":"Txt_root__MIsTC","primary":"Txt_primary__8c4gL","secondary":"Txt_secondary__b-h2H"};